import DownloadIcon from './DownloadIcon';
import NewsroomIcon from './NewsroomIcon';
import PerformancesIcon from './PerformancesIcon';
import SearchIcon from './SearchIcon';

const ICONS: Record<
  string,
  | typeof SearchIcon
  | typeof DownloadIcon
  | typeof NewsroomIcon
  | typeof PerformancesIcon
> = {
  search: SearchIcon,
  download: DownloadIcon,
  newsroom: NewsroomIcon,
  financial: PerformancesIcon,
};

export default ICONS;
